import slugify from 'slugify';
import each from 'lodash/each';

export const slugifyString = (str) => str && slugify(str, {
  lower: true,
  strict: true   // strip special characters except replacement chars (https://github.com/simov/slugify/blob/master/config/charmap.json)
});

export const insertOrReplaceUrlParam = (url, paramName, paramValue)=> {
  return insertOrReplaceUrlParams(url, { [paramName]: paramValue });
};

export const insertOrReplaceUrlParams = (url, paramsObj)=> {
  const urlObj = new URL(url);
  each(paramsObj, (val, key)=> {
    urlObj.searchParams.set(key, val);
  });
  return urlObj.toString();  
};

export const getDomainFromUrl = (url)=> {
  var linkParser = window.document.createElement('a'); 
  linkParser.href = url;
  // IE weirdness, otherwise host is empty
  // see https://gist.github.com/jlong/2428561#gistcomment-1461205
  linkParser.href = linkParser.href; 
  // Remove whitespace from ends of hostname
  const hostname = window.encodeURIComponent($.trim(window.decodeURIComponent(linkParser.hostname)));
  return hostname;
};

/**
 * strips a param from a query string and returns a valid query string.
 * @TODO ideally the logic belongs in `getQueryStringWithoutParamList`
 * and this is just the single case of that, 
 * but for now the logic only handles one at a time
 */
export const getQueryStringWithoutParam = (oldQueryString, paramKey) => {
  if (!oldQueryString || oldQueryString.indexOf(paramKey+'=') === -1) {
    return oldQueryString;
  }
  var newQueryString = '';
  if (oldQueryString[0] == '?') {
    oldQueryString = oldQueryString.substr(1);
  }
  var queryPieces = oldQueryString.split('&');
  // build a string that looks like `&key1=val1&val2=val2`
  // except without the key we want to strip
  for (let i = 0; i < queryPieces.length; i++) {
    if (queryPieces[i] && queryPieces[i].indexOf(paramKey+'=') === -1) {
      newQueryString += '&' + queryPieces[i];
    }
  }
  if (newQueryString) {
    // turn the leading & into a ?
    return '?' + newQueryString.substr(1);
  }
  return '';
};

export const getQueryStringWithoutParamList =  (oldQueryString, paramKeyList) => {
  var queryString = oldQueryString;
  while (paramKeyList.length) {
    let paramKey = paramKeyList.pop();
    queryString = getQueryStringWithoutParam(queryString, paramKey);
  }
  return queryString;
};
